var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 45,
    viewBox: "0 0 53 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1144_38340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9925 17.0389C21.1637 17.0389 22.9303 15.2726 22.9303 13.1011V5.0736C22.9303 4.48222 22.4507 4.00293 21.8596 4.00293H16.1254C15.5343 4.00293 15.0547 4.48222 15.0547 5.0736V13.1011C15.0547 15.2726 16.8213 17.0389 18.9925 17.0389Z",
    fill: "#BDC3C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3266 12.0303H25.0707V13.1009C25.0707 16.4529 22.3435 19.1801 18.9916 19.1801C15.6396 19.1801 12.9124 16.4529 12.9124 13.1009V12.0303H4.65654C2.48536 12.0303 0.71875 13.7969 0.71875 15.9681V36.6106C0.71875 38.782 2.48536 40.5484 4.65654 40.5484H33.3266C35.498 40.5484 37.2644 38.782 37.2644 36.6106V15.9681C37.2644 13.7969 35.498 12.0303 33.3266 12.0303ZM17.1951 34.1648C17.1951 34.7561 16.7158 35.2354 16.1244 35.2354H7.52337C6.93227 35.2354 6.4527 34.7561 6.4527 34.1648V32.7313C6.4527 30.8398 7.4361 29.175 8.91804 28.2178C8.27758 27.5174 7.8864 26.5853 7.8864 25.5637C7.8864 23.3925 9.65273 21.6259 11.8239 21.6259C13.9954 21.6259 15.7617 23.3925 15.7617 25.5637C15.7617 26.5853 15.3705 27.5171 14.7301 28.2178C16.2117 29.175 17.1951 30.8398 17.1951 32.7313V34.1648ZM30.4597 35.2354H21.8587C21.2673 35.2354 20.788 34.7561 20.788 34.1648C20.788 33.5734 21.2673 33.0941 21.8587 33.0941H30.4597C31.0508 33.0941 31.5304 33.5734 31.5304 34.1648C31.5304 34.7561 31.0508 35.2354 30.4597 35.2354ZM30.4597 29.5015H21.8587C21.2673 29.5015 20.788 29.0222 20.788 28.4308C20.788 27.8394 21.2673 27.3601 21.8587 27.3601H30.4597C31.0508 27.3601 31.5304 27.8394 31.5304 28.4308C31.5304 29.0222 31.0508 29.5015 30.4597 29.5015ZM30.4597 23.7672H21.8587C21.2673 23.7672 20.788 23.2879 20.788 22.6966C20.788 22.1055 21.2673 21.6259 21.8587 21.6259H30.4597C31.0508 21.6259 31.5304 22.1055 31.5304 22.6966C31.5304 23.2879 31.0508 23.7672 30.4597 23.7672Z",
    fill: "#BDC3C6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8828 0.348633V44.2035",
    stroke: "#D6DCDF",
    strokeWidth: 1.82729
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1144_38340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.5456,
    height: 36.5456,
    fill: "white",
    transform: "translate(0.71875 4.00293)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleIcon);
export default __webpack_public_path__ + "static/media/role-icon.e6f16d4939b85dc2c300df4b55f4a206.svg";
export { ForwardRef as ReactComponent };